(function ($) {
  Drupal.behaviors.productVideoV1 = {
    attach: function (context, settings) {
      var $videoContainer = $('.product-full__video', context);
      var $videoReveal = $('.js-video-reveal', context);
      var $playBtn = $('.js-play', context);

      $playBtn.once().on('click', function () {
        var $youTubeContent = $('<iframe></iframe>');

        $youTubeContent.addClass('youtube-video')
          .attr('frameborder', 0)
          .attr('allowfullscreen', 1)
          .attr('title', 'YouTube Video Player')
          .attr('width', '100%')
          .attr('height', '100%')
          .attr('src', 'https://www.youtube.com/embed/' + $videoContainer.data('youtube-id') + '?autoplay=1&amp;modestbranding=0&amp;controls=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1&amp;origin=' + location.origin + '&amp;widgetid=1');
        $videoReveal.append($youTubeContent);
        $videoReveal.removeClass('hidden');
      });
    }
  };
})(jQuery);
